import { render, staticRenderFns } from "./servicefacedetail.vue?vue&type=template&id=daf0e182&scoped=true&"
import script from "./servicefacedetail.vue?vue&type=script&lang=js&"
export * from "./servicefacedetail.vue?vue&type=script&lang=js&"
import style0 from "./servicefacedetail.vue?vue&type=style&index=0&id=daf0e182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf0e182",
  null
  
)

export default component.exports